import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNitridingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .a {\n        fill: #fdfdfd;\n        opacity: 0;\n      }\n\n      .b {\n        fill: #fff;\n      }\n\n      .c {\n        fill: #768088;\n      }\n\n      .d {\n        fill: #05b1ca;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-white",
			points: "12.498 6.918 3.533 12.094 3.533 14.682 12.554 19.891 21.519 14.715 21.519 12.127 12.498 6.918"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M21.519,11.87a.257.257,0,0,0-.256.257v2.44l-8.452,4.88V17.3a.257.257,0,0,0-.513,0v2.145L3.79,14.534v-2.44a.257.257,0,0,0-.513,0v2.588a.255.255,0,0,0,.128.222l9.021,5.208a.251.251,0,0,0,.128.035.255.255,0,0,0,.129-.035l8.964-5.175a.256.256,0,0,0,.128-.222V12.127A.257.257,0,0,0,21.519,11.87Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M16.336,10.636a1,1,0,0,0-.9,0,.3.3,0,0,0-.182.291l-.586.185a3.345,3.345,0,0,0-2.08-.633,2.726,2.726,0,0,0-2.41,1.029l-.692-.076a.453.453,0,0,0-.221-.244,1.234,1.234,0,0,0-1.118,0c-.308.177-.306.466,0,.645a1.234,1.234,0,0,0,1.118,0,.6.6,0,0,0,.116-.086l.694.076a.788.788,0,0,0-.007.109c0,.73.937,1.337,2.152,1.445l-.077.533a1.354,1.354,0,0,0-.606.16.419.419,0,0,0,0,.793,1.518,1.518,0,0,0,1.372,0,.418.418,0,0,0,0-.792,1.246,1.246,0,0,0-.442-.146l.077-.534H12.6c1.394,0,2.52-.648,2.516-1.453a.958.958,0,0,0-.2-.568l.587-.186a1.006,1.006,0,0,0,.834-.03A.274.274,0,0,0,16.336,10.636Zm-3.062,2.1-1.229-.856,0,.854-.769,0-.008-1.6h.646l1.229.855-.005-.853h.769l.009,1.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M4.14,11.744h0a.284.284,0,0,0-.388-.1l-.36.208a.283.283,0,0,0,0,.491l.36.208a.282.282,0,0,0,.142.038.283.283,0,0,0,.192-.492A.285.285,0,0,0,4.14,11.744Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M4.757,12.474a.283.283,0,1,0-.283.491l.721.416a.283.283,0,1,0,.284-.49Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M6.639,9.974l-.722.417a.283.283,0,0,0,.284.49l.721-.416a.283.283,0,1,0-.283-.491Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M6.2,13.307a.285.285,0,0,0-.388.1.284.284,0,0,0,.1.387l.722.417a.289.289,0,0,0,.141.038.283.283,0,0,0,.142-.529Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M4.616,11.753a.289.289,0,0,0,.141-.038l.722-.417a.284.284,0,1,0-.284-.491l-.721.417a.278.278,0,0,0-.132.172.283.283,0,0,0,.028.215A.287.287,0,0,0,4.616,11.753Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M16.743,9.7a.281.281,0,0,0,.141.038.283.283,0,0,0,.142-.529l-.721-.416a.283.283,0,1,0-.284.49Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M15.3,8.863a.284.284,0,0,0,.284-.491l-.722-.417a.283.283,0,1,0-.283.491Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M13.855,8.029a.283.283,0,1,0,.285-.49l-.722-.417a.285.285,0,0,0-.388.1.284.284,0,0,0,.1.387Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M7.5,10.086a.281.281,0,0,0,.141-.038l.722-.417a.283.283,0,1,0-.284-.49l-.722.416a.284.284,0,0,0,.143.529Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M7.644,14.141a.28.28,0,0,0-.215-.029.286.286,0,0,0-.172.132.285.285,0,0,0,.1.387l.722.417a.282.282,0,0,0,.142.038.283.283,0,0,0,.142-.529Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M8.946,9.253a.3.3,0,0,0,.142-.038L9.809,8.8a.284.284,0,1,0-.284-.491L8.8,8.724a.278.278,0,0,0-.132.172.283.283,0,0,0,.028.215A.287.287,0,0,0,8.946,9.253Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M11.833,7.586a.282.282,0,0,0,.142-.038l.546-.315a.28.28,0,0,0,.279-.141.284.284,0,0,0-.105-.387l-.055-.032a.288.288,0,0,0-.284,0l-.666.384a.284.284,0,0,0,.143.529Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M10.39,8.419a.284.284,0,0,0,.141-.038l.721-.416a.283.283,0,1,0-.283-.491l-.722.417a.283.283,0,0,0,.143.528Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M15.187,15.455l-.722.417a.282.282,0,0,0-.132.172.279.279,0,0,0,.028.215.285.285,0,0,0,.246.142.288.288,0,0,0,.142-.038l.721-.417a.283.283,0,0,0-.283-.491Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M19.191,10.455a.283.283,0,1,0-.283.491l.721.417a.283.283,0,0,0,.416-.318.281.281,0,0,0-.132-.173Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M19.517,12.955l-.722.417a.283.283,0,0,0,.142.529.285.285,0,0,0,.142-.038l.721-.417a.283.283,0,0,0-.283-.491Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M17.748,9.622a.284.284,0,1,0-.284.491l.722.416a.282.282,0,0,0,.141.039.284.284,0,0,0,.143-.529Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M21.356,11.705l-.721-.416a.283.283,0,1,0-.284.49l.6.348-.714.412a.283.283,0,1,0,.284.49l.722-.416a.285.285,0,0,0,.1-.387c-.006-.01-.019-.011-.026-.02a.275.275,0,0,0,.035-.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M18.073,13.789l-.721.416a.283.283,0,1,0,.283.491l.722-.417a.283.283,0,0,0-.284-.49Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M9.088,14.974a.284.284,0,1,0-.284.491l.721.416a.284.284,0,0,0,.388-.1.276.276,0,0,0,.028-.214.273.273,0,0,0-.132-.172Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M11.975,16.641a.283.283,0,0,0-.388.1.285.285,0,0,0,.1.387l.722.417a.282.282,0,0,0,.142.038.283.283,0,0,0,.142-.529Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M13.958,16.26a.283.283,0,0,0-.215.029l-.722.416a.284.284,0,0,0,.284.491l.721-.417a.284.284,0,0,0-.068-.519Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M10.531,15.807a.284.284,0,0,0-.284.491l.722.417a.292.292,0,0,0,.141.038.283.283,0,0,0,.142-.529Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M16.845,14.594a.282.282,0,0,0-.215.028l-.722.417a.283.283,0,1,0,.284.49l.722-.416a.284.284,0,0,0,.1-.387A.278.278,0,0,0,16.845,14.594Z"
		})
	]
});
export default SvgNitridingSm;
